/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/
import * as thrift from "thrift";
import * as GenericExceptions from "./../../thrift/protocol/common/exceptions";
import * as PHeader from "./../../thrift/protocol/common/models";
import * as PDirectory from "./../../thrift/protocol/duck/messages";
export namespace TDirectoryMemberService {
    export interface IAddDirectoryMemberInfoArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TAddDirectoryMemberInfoRequest;
    }
    export class AddDirectoryMemberInfoArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TAddDirectoryMemberInfoRequest;
        constructor(args: IAddDirectoryMemberInfoArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("AddDirectoryMemberInfoArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): AddDirectoryMemberInfoArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_1: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_1;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_2: PDirectory.TAddDirectoryMemberInfoRequest = PDirectory.TAddDirectoryMemberInfoRequest.read(input);
                            _args.request = value_2;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new AddDirectoryMemberInfoArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read AddDirectoryMemberInfoArgs from input");
            }
        }
    }
    export interface IUpdateDirectoryMemberInfoArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TUpdateDirectoryMemberInfoRequest;
    }
    export class UpdateDirectoryMemberInfoArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TUpdateDirectoryMemberInfoRequest;
        constructor(args: IUpdateDirectoryMemberInfoArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateDirectoryMemberInfoArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateDirectoryMemberInfoArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_3: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_3;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_4: PDirectory.TUpdateDirectoryMemberInfoRequest = PDirectory.TUpdateDirectoryMemberInfoRequest.read(input);
                            _args.request = value_4;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new UpdateDirectoryMemberInfoArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read UpdateDirectoryMemberInfoArgs from input");
            }
        }
    }
    export interface IDeleteDirectoryMemberInfoArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TDeleteDirectoryMemberInfoRequest;
    }
    export class DeleteDirectoryMemberInfoArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TDeleteDirectoryMemberInfoRequest;
        constructor(args: IDeleteDirectoryMemberInfoArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("DeleteDirectoryMemberInfoArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): DeleteDirectoryMemberInfoArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_5: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_5;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_6: PDirectory.TDeleteDirectoryMemberInfoRequest = PDirectory.TDeleteDirectoryMemberInfoRequest.read(input);
                            _args.request = value_6;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new DeleteDirectoryMemberInfoArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read DeleteDirectoryMemberInfoArgs from input");
            }
        }
    }
    export interface IFetchDirectoryMemberArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TFetchDirectoryMemberRequest;
    }
    export class FetchDirectoryMemberArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TFetchDirectoryMemberRequest;
        constructor(args: IFetchDirectoryMemberArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoryMemberArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoryMemberArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_7: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_7;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_8: PDirectory.TFetchDirectoryMemberRequest = PDirectory.TFetchDirectoryMemberRequest.read(input);
                            _args.request = value_8;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new FetchDirectoryMemberArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FetchDirectoryMemberArgs from input");
            }
        }
    }
    export interface IFetchLatestMemberInfoArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TFetchLatestMemberInfoRequest;
    }
    export class FetchLatestMemberInfoArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TFetchLatestMemberInfoRequest;
        constructor(args: IFetchLatestMemberInfoArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchLatestMemberInfoArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchLatestMemberInfoArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_9: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_9;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_10: PDirectory.TFetchLatestMemberInfoRequest = PDirectory.TFetchLatestMemberInfoRequest.read(input);
                            _args.request = value_10;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new FetchLatestMemberInfoArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FetchLatestMemberInfoArgs from input");
            }
        }
    }
    export interface IFetchDirectoryMembersArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TFetchDirectoryMembersRequest;
    }
    export class FetchDirectoryMembersArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TFetchDirectoryMembersRequest;
        constructor(args: IFetchDirectoryMembersArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoryMembersArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoryMembersArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_11: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_11;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_12: PDirectory.TFetchDirectoryMembersRequest = PDirectory.TFetchDirectoryMembersRequest.read(input);
                            _args.request = value_12;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new FetchDirectoryMembersArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FetchDirectoryMembersArgs from input");
            }
        }
    }
    export interface ICreateMemberVCFArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TCreateMemberVCFRequest;
    }
    export class CreateMemberVCFArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TCreateMemberVCFRequest;
        constructor(args: ICreateMemberVCFArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("CreateMemberVCFArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): CreateMemberVCFArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_13: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_13;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_14: PDirectory.TCreateMemberVCFRequest = PDirectory.TCreateMemberVCFRequest.read(input);
                            _args.request = value_14;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new CreateMemberVCFArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read CreateMemberVCFArgs from input");
            }
        }
    }
    export interface ICreateMembersVCFArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TCreateMembersVCFRequest;
    }
    export class CreateMembersVCFArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TCreateMembersVCFRequest;
        constructor(args: ICreateMembersVCFArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("CreateMembersVCFArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): CreateMembersVCFArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_15: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_15;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_16: PDirectory.TCreateMembersVCFRequest = PDirectory.TCreateMembersVCFRequest.read(input);
                            _args.request = value_16;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new CreateMembersVCFArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read CreateMembersVCFArgs from input");
            }
        }
    }
    export interface ICreateMembersCSVArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TCreateMembersCSVRequest;
    }
    export class CreateMembersCSVArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TCreateMembersCSVRequest;
        constructor(args: ICreateMembersCSVArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("CreateMembersCSVArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): CreateMembersCSVArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_17: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_17;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_18: PDirectory.TCreateMembersCSVRequest = PDirectory.TCreateMembersCSVRequest.read(input);
                            _args.request = value_18;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new CreateMembersCSVArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read CreateMembersCSVArgs from input");
            }
        }
    }
    export interface IInviteDirectoryMemberArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TInviteDirectoryMemberRequest;
    }
    export class InviteDirectoryMemberArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TInviteDirectoryMemberRequest;
        constructor(args: IInviteDirectoryMemberArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("InviteDirectoryMemberArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): InviteDirectoryMemberArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_19: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_19;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_20: PDirectory.TInviteDirectoryMemberRequest = PDirectory.TInviteDirectoryMemberRequest.read(input);
                            _args.request = value_20;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new InviteDirectoryMemberArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read InviteDirectoryMemberArgs from input");
            }
        }
    }
    export interface IInviteDirectoryMembersArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TInviteDirectoryMembersRequest;
    }
    export class InviteDirectoryMembersArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TInviteDirectoryMembersRequest;
        constructor(args: IInviteDirectoryMembersArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("InviteDirectoryMembersArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): InviteDirectoryMembersArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_21: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_21;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_22: PDirectory.TInviteDirectoryMembersRequest = PDirectory.TInviteDirectoryMembersRequest.read(input);
                            _args.request = value_22;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new InviteDirectoryMembersArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read InviteDirectoryMembersArgs from input");
            }
        }
    }
    export interface IFetchInvitedDirectoryMembersArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TFetchInvitedDirectoryMembersRequest;
    }
    export class FetchInvitedDirectoryMembersArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TFetchInvitedDirectoryMembersRequest;
        constructor(args: IFetchInvitedDirectoryMembersArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchInvitedDirectoryMembersArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchInvitedDirectoryMembersArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_23: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_23;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_24: PDirectory.TFetchInvitedDirectoryMembersRequest = PDirectory.TFetchInvitedDirectoryMembersRequest.read(input);
                            _args.request = value_24;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new FetchInvitedDirectoryMembersArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FetchInvitedDirectoryMembersArgs from input");
            }
        }
    }
    export interface IRemoveDirectoryInviteArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TRemoveDirectoryInviteRequest;
    }
    export class RemoveDirectoryInviteArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TRemoveDirectoryInviteRequest;
        constructor(args: IRemoveDirectoryInviteArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("RemoveDirectoryInviteArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): RemoveDirectoryInviteArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_25: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_25;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_26: PDirectory.TRemoveDirectoryInviteRequest = PDirectory.TRemoveDirectoryInviteRequest.read(input);
                            _args.request = value_26;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new RemoveDirectoryInviteArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read RemoveDirectoryInviteArgs from input");
            }
        }
    }
    export interface IFetchDirectoryNotificationPreferenceArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TFetchDirectoryNotificationPreferenceRequest;
    }
    export class FetchDirectoryNotificationPreferenceArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TFetchDirectoryNotificationPreferenceRequest;
        constructor(args: IFetchDirectoryNotificationPreferenceArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoryNotificationPreferenceArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoryNotificationPreferenceArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_27: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_27;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_28: PDirectory.TFetchDirectoryNotificationPreferenceRequest = PDirectory.TFetchDirectoryNotificationPreferenceRequest.read(input);
                            _args.request = value_28;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new FetchDirectoryNotificationPreferenceArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FetchDirectoryNotificationPreferenceArgs from input");
            }
        }
    }
    export interface IUpdateDirectoryNotificationPreferenceArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TUpdateDirectoryNotificationPreferenceRequest;
    }
    export class UpdateDirectoryNotificationPreferenceArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TUpdateDirectoryNotificationPreferenceRequest;
        constructor(args: IUpdateDirectoryNotificationPreferenceArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateDirectoryNotificationPreferenceArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateDirectoryNotificationPreferenceArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_29: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_29;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_30: PDirectory.TUpdateDirectoryNotificationPreferenceRequest = PDirectory.TUpdateDirectoryNotificationPreferenceRequest.read(input);
                            _args.request = value_30;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new UpdateDirectoryNotificationPreferenceArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read UpdateDirectoryNotificationPreferenceArgs from input");
            }
        }
    }
    export interface IAddDirectoryMemberInfoResultArgs {
        success?: PDirectory.TAddDirectoryMemberInfoResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
        invalidPasscodeError?: GenericExceptions.TInvalidPasscodeException;
    }
    export class AddDirectoryMemberInfoResult {
        public success?: PDirectory.TAddDirectoryMemberInfoResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        public invalidPasscodeError?: GenericExceptions.TInvalidPasscodeException;
        constructor(args?: IAddDirectoryMemberInfoResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
            if (args != null && args.invalidPasscodeError != null) {
                this.invalidPasscodeError = args.invalidPasscodeError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("AddDirectoryMemberInfoResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidPasscodeError != null) {
                output.writeFieldBegin("invalidPasscodeError", thrift.Thrift.Type.STRUCT, 3);
                this.invalidPasscodeError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): AddDirectoryMemberInfoResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_31: PDirectory.TAddDirectoryMemberInfoResponse = PDirectory.TAddDirectoryMemberInfoResponse.read(input);
                            _args.success = value_31;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_32: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_32;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_33: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_33;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 3:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_34: GenericExceptions.TInvalidPasscodeException = GenericExceptions.TInvalidPasscodeException.read(input);
                            _args.invalidPasscodeError = value_34;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new AddDirectoryMemberInfoResult(_args);
        }
    }
    export interface IUpdateDirectoryMemberInfoResultArgs {
        success?: PDirectory.TUpdateDirectoryMemberInfoResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class UpdateDirectoryMemberInfoResult {
        public success?: PDirectory.TUpdateDirectoryMemberInfoResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IUpdateDirectoryMemberInfoResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateDirectoryMemberInfoResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateDirectoryMemberInfoResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_35: PDirectory.TUpdateDirectoryMemberInfoResponse = PDirectory.TUpdateDirectoryMemberInfoResponse.read(input);
                            _args.success = value_35;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_36: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_36;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_37: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_37;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new UpdateDirectoryMemberInfoResult(_args);
        }
    }
    export interface IDeleteDirectoryMemberInfoResultArgs {
        success?: PDirectory.TDeleteDirectoryMemberInfoResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class DeleteDirectoryMemberInfoResult {
        public success?: PDirectory.TDeleteDirectoryMemberInfoResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IDeleteDirectoryMemberInfoResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("DeleteDirectoryMemberInfoResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): DeleteDirectoryMemberInfoResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_38: PDirectory.TDeleteDirectoryMemberInfoResponse = PDirectory.TDeleteDirectoryMemberInfoResponse.read(input);
                            _args.success = value_38;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_39: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_39;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_40: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_40;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new DeleteDirectoryMemberInfoResult(_args);
        }
    }
    export interface IFetchDirectoryMemberResultArgs {
        success?: PDirectory.TFetchDirectoryMemberResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class FetchDirectoryMemberResult {
        public success?: PDirectory.TFetchDirectoryMemberResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IFetchDirectoryMemberResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoryMemberResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoryMemberResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_41: PDirectory.TFetchDirectoryMemberResponse = PDirectory.TFetchDirectoryMemberResponse.read(input);
                            _args.success = value_41;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_42: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_42;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_43: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_43;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FetchDirectoryMemberResult(_args);
        }
    }
    export interface IFetchLatestMemberInfoResultArgs {
        success?: PDirectory.TFetchLatestMemberInfoResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class FetchLatestMemberInfoResult {
        public success?: PDirectory.TFetchLatestMemberInfoResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IFetchLatestMemberInfoResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchLatestMemberInfoResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchLatestMemberInfoResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_44: PDirectory.TFetchLatestMemberInfoResponse = PDirectory.TFetchLatestMemberInfoResponse.read(input);
                            _args.success = value_44;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_45: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_45;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_46: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_46;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FetchLatestMemberInfoResult(_args);
        }
    }
    export interface IFetchDirectoryMembersResultArgs {
        success?: PDirectory.TFetchDirectoryMembersResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class FetchDirectoryMembersResult {
        public success?: PDirectory.TFetchDirectoryMembersResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IFetchDirectoryMembersResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoryMembersResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoryMembersResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_47: PDirectory.TFetchDirectoryMembersResponse = PDirectory.TFetchDirectoryMembersResponse.read(input);
                            _args.success = value_47;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_48: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_48;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_49: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_49;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FetchDirectoryMembersResult(_args);
        }
    }
    export interface ICreateMemberVCFResultArgs {
        success?: PDirectory.TCreateMemberVCFResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class CreateMemberVCFResult {
        public success?: PDirectory.TCreateMemberVCFResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: ICreateMemberVCFResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("CreateMemberVCFResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): CreateMemberVCFResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_50: PDirectory.TCreateMemberVCFResponse = PDirectory.TCreateMemberVCFResponse.read(input);
                            _args.success = value_50;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_51: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_51;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_52: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_52;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new CreateMemberVCFResult(_args);
        }
    }
    export interface ICreateMembersVCFResultArgs {
        success?: PDirectory.TCreateMembersVCFResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class CreateMembersVCFResult {
        public success?: PDirectory.TCreateMembersVCFResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: ICreateMembersVCFResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("CreateMembersVCFResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): CreateMembersVCFResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_53: PDirectory.TCreateMembersVCFResponse = PDirectory.TCreateMembersVCFResponse.read(input);
                            _args.success = value_53;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_54: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_54;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_55: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_55;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new CreateMembersVCFResult(_args);
        }
    }
    export interface ICreateMembersCSVResultArgs {
        success?: PDirectory.TCreateMembersCSVResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class CreateMembersCSVResult {
        public success?: PDirectory.TCreateMembersCSVResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: ICreateMembersCSVResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("CreateMembersCSVResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): CreateMembersCSVResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_56: PDirectory.TCreateMembersCSVResponse = PDirectory.TCreateMembersCSVResponse.read(input);
                            _args.success = value_56;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_57: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_57;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_58: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_58;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new CreateMembersCSVResult(_args);
        }
    }
    export interface IInviteDirectoryMemberResultArgs {
        success?: PDirectory.TInviteDirectoryMemberResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class InviteDirectoryMemberResult {
        public success?: PDirectory.TInviteDirectoryMemberResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IInviteDirectoryMemberResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("InviteDirectoryMemberResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): InviteDirectoryMemberResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_59: PDirectory.TInviteDirectoryMemberResponse = PDirectory.TInviteDirectoryMemberResponse.read(input);
                            _args.success = value_59;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_60: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_60;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_61: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_61;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new InviteDirectoryMemberResult(_args);
        }
    }
    export interface IInviteDirectoryMembersResultArgs {
        success?: PDirectory.TInviteDirectoryMembersResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class InviteDirectoryMembersResult {
        public success?: PDirectory.TInviteDirectoryMembersResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IInviteDirectoryMembersResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("InviteDirectoryMembersResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): InviteDirectoryMembersResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_62: PDirectory.TInviteDirectoryMembersResponse = PDirectory.TInviteDirectoryMembersResponse.read(input);
                            _args.success = value_62;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_63: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_63;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_64: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_64;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new InviteDirectoryMembersResult(_args);
        }
    }
    export interface IFetchInvitedDirectoryMembersResultArgs {
        success?: PDirectory.TFetchInvitedDirectoryMembersResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class FetchInvitedDirectoryMembersResult {
        public success?: PDirectory.TFetchInvitedDirectoryMembersResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IFetchInvitedDirectoryMembersResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchInvitedDirectoryMembersResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchInvitedDirectoryMembersResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_65: PDirectory.TFetchInvitedDirectoryMembersResponse = PDirectory.TFetchInvitedDirectoryMembersResponse.read(input);
                            _args.success = value_65;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_66: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_66;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_67: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_67;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FetchInvitedDirectoryMembersResult(_args);
        }
    }
    export interface IRemoveDirectoryInviteResultArgs {
        success?: PDirectory.TRemoveDirectoryInviteResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class RemoveDirectoryInviteResult {
        public success?: PDirectory.TRemoveDirectoryInviteResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IRemoveDirectoryInviteResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("RemoveDirectoryInviteResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): RemoveDirectoryInviteResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_68: PDirectory.TRemoveDirectoryInviteResponse = PDirectory.TRemoveDirectoryInviteResponse.read(input);
                            _args.success = value_68;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_69: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_69;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_70: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_70;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new RemoveDirectoryInviteResult(_args);
        }
    }
    export interface IFetchDirectoryNotificationPreferenceResultArgs {
        success?: PDirectory.TFetchDirectoryNotificationPreferenceResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class FetchDirectoryNotificationPreferenceResult {
        public success?: PDirectory.TFetchDirectoryNotificationPreferenceResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IFetchDirectoryNotificationPreferenceResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoryNotificationPreferenceResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoryNotificationPreferenceResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_71: PDirectory.TFetchDirectoryNotificationPreferenceResponse = PDirectory.TFetchDirectoryNotificationPreferenceResponse.read(input);
                            _args.success = value_71;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_72: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_72;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_73: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_73;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FetchDirectoryNotificationPreferenceResult(_args);
        }
    }
    export interface IUpdateDirectoryNotificationPreferenceResultArgs {
        success?: PDirectory.TUpdateDirectoryNotificationPreferenceResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class UpdateDirectoryNotificationPreferenceResult {
        public success?: PDirectory.TUpdateDirectoryNotificationPreferenceResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IUpdateDirectoryNotificationPreferenceResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateDirectoryNotificationPreferenceResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateDirectoryNotificationPreferenceResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_74: PDirectory.TUpdateDirectoryNotificationPreferenceResponse = PDirectory.TUpdateDirectoryNotificationPreferenceResponse.read(input);
                            _args.success = value_74;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_75: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_75;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_76: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_76;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new UpdateDirectoryNotificationPreferenceResult(_args);
        }
    }
    export class Client {
        public _seqid: number;
        public _reqs: {
            [name: number]: (err: Error | object | undefined, val?: any) => void;
        };
        public output: thrift.TTransport;
        public protocol: new (trans: thrift.TTransport) => thrift.TProtocol;
        constructor(output: thrift.TTransport, protocol: new (trans: thrift.TTransport) => thrift.TProtocol) {
            this._seqid = 0;
            this._reqs = {};
            this.output = output;
            this.protocol = protocol;
        }
        public incrementSeqId(): number {
            return this._seqid += 1;
        }
        public addDirectoryMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TAddDirectoryMemberInfoRequest): Promise<PDirectory.TAddDirectoryMemberInfoResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TAddDirectoryMemberInfoResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_addDirectoryMemberInfo(header, request, requestId);
            });
        }
        public updateDirectoryMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TUpdateDirectoryMemberInfoRequest): Promise<PDirectory.TUpdateDirectoryMemberInfoResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TUpdateDirectoryMemberInfoResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_updateDirectoryMemberInfo(header, request, requestId);
            });
        }
        public deleteDirectoryMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TDeleteDirectoryMemberInfoRequest): Promise<PDirectory.TDeleteDirectoryMemberInfoResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TDeleteDirectoryMemberInfoResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_deleteDirectoryMemberInfo(header, request, requestId);
            });
        }
        public fetchDirectoryMember(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryMemberRequest): Promise<PDirectory.TFetchDirectoryMemberResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TFetchDirectoryMemberResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fetchDirectoryMember(header, request, requestId);
            });
        }
        public fetchLatestMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TFetchLatestMemberInfoRequest): Promise<PDirectory.TFetchLatestMemberInfoResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TFetchLatestMemberInfoResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fetchLatestMemberInfo(header, request, requestId);
            });
        }
        public fetchDirectoryMembers(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryMembersRequest): Promise<PDirectory.TFetchDirectoryMembersResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TFetchDirectoryMembersResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fetchDirectoryMembers(header, request, requestId);
            });
        }
        public createMemberVCF(header: PHeader.TAuthHeader, request: PDirectory.TCreateMemberVCFRequest): Promise<PDirectory.TCreateMemberVCFResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TCreateMemberVCFResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_createMemberVCF(header, request, requestId);
            });
        }
        public createMembersVCF(header: PHeader.TAuthHeader, request: PDirectory.TCreateMembersVCFRequest): Promise<PDirectory.TCreateMembersVCFResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TCreateMembersVCFResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_createMembersVCF(header, request, requestId);
            });
        }
        public createMembersCSV(header: PHeader.TAuthHeader, request: PDirectory.TCreateMembersCSVRequest): Promise<PDirectory.TCreateMembersCSVResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TCreateMembersCSVResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_createMembersCSV(header, request, requestId);
            });
        }
        public inviteDirectoryMember(header: PHeader.TAuthHeader, request: PDirectory.TInviteDirectoryMemberRequest): Promise<PDirectory.TInviteDirectoryMemberResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TInviteDirectoryMemberResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_inviteDirectoryMember(header, request, requestId);
            });
        }
        public inviteDirectoryMembers(header: PHeader.TAuthHeader, request: PDirectory.TInviteDirectoryMembersRequest): Promise<PDirectory.TInviteDirectoryMembersResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TInviteDirectoryMembersResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_inviteDirectoryMembers(header, request, requestId);
            });
        }
        public fetchInvitedDirectoryMembers(header: PHeader.TAuthHeader, request: PDirectory.TFetchInvitedDirectoryMembersRequest): Promise<PDirectory.TFetchInvitedDirectoryMembersResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TFetchInvitedDirectoryMembersResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fetchInvitedDirectoryMembers(header, request, requestId);
            });
        }
        public removeDirectoryInvite(header: PHeader.TAuthHeader, request: PDirectory.TRemoveDirectoryInviteRequest): Promise<PDirectory.TRemoveDirectoryInviteResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TRemoveDirectoryInviteResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_removeDirectoryInvite(header, request, requestId);
            });
        }
        public fetchDirectoryNotificationPreference(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryNotificationPreferenceRequest): Promise<PDirectory.TFetchDirectoryNotificationPreferenceResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TFetchDirectoryNotificationPreferenceResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fetchDirectoryNotificationPreference(header, request, requestId);
            });
        }
        public updateDirectoryNotificationPreference(header: PHeader.TAuthHeader, request: PDirectory.TUpdateDirectoryNotificationPreferenceRequest): Promise<PDirectory.TUpdateDirectoryNotificationPreferenceResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TUpdateDirectoryNotificationPreferenceResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_updateDirectoryNotificationPreference(header, request, requestId);
            });
        }
        public send_addDirectoryMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TAddDirectoryMemberInfoRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("addDirectoryMemberInfo", thrift.Thrift.MessageType.CALL, requestId);
            const args: AddDirectoryMemberInfoArgs = new AddDirectoryMemberInfoArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_updateDirectoryMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TUpdateDirectoryMemberInfoRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("updateDirectoryMemberInfo", thrift.Thrift.MessageType.CALL, requestId);
            const args: UpdateDirectoryMemberInfoArgs = new UpdateDirectoryMemberInfoArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_deleteDirectoryMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TDeleteDirectoryMemberInfoRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("deleteDirectoryMemberInfo", thrift.Thrift.MessageType.CALL, requestId);
            const args: DeleteDirectoryMemberInfoArgs = new DeleteDirectoryMemberInfoArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fetchDirectoryMember(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryMemberRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fetchDirectoryMember", thrift.Thrift.MessageType.CALL, requestId);
            const args: FetchDirectoryMemberArgs = new FetchDirectoryMemberArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fetchLatestMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TFetchLatestMemberInfoRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fetchLatestMemberInfo", thrift.Thrift.MessageType.CALL, requestId);
            const args: FetchLatestMemberInfoArgs = new FetchLatestMemberInfoArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fetchDirectoryMembers(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryMembersRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fetchDirectoryMembers", thrift.Thrift.MessageType.CALL, requestId);
            const args: FetchDirectoryMembersArgs = new FetchDirectoryMembersArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_createMemberVCF(header: PHeader.TAuthHeader, request: PDirectory.TCreateMemberVCFRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("createMemberVCF", thrift.Thrift.MessageType.CALL, requestId);
            const args: CreateMemberVCFArgs = new CreateMemberVCFArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_createMembersVCF(header: PHeader.TAuthHeader, request: PDirectory.TCreateMembersVCFRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("createMembersVCF", thrift.Thrift.MessageType.CALL, requestId);
            const args: CreateMembersVCFArgs = new CreateMembersVCFArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_createMembersCSV(header: PHeader.TAuthHeader, request: PDirectory.TCreateMembersCSVRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("createMembersCSV", thrift.Thrift.MessageType.CALL, requestId);
            const args: CreateMembersCSVArgs = new CreateMembersCSVArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_inviteDirectoryMember(header: PHeader.TAuthHeader, request: PDirectory.TInviteDirectoryMemberRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("inviteDirectoryMember", thrift.Thrift.MessageType.CALL, requestId);
            const args: InviteDirectoryMemberArgs = new InviteDirectoryMemberArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_inviteDirectoryMembers(header: PHeader.TAuthHeader, request: PDirectory.TInviteDirectoryMembersRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("inviteDirectoryMembers", thrift.Thrift.MessageType.CALL, requestId);
            const args: InviteDirectoryMembersArgs = new InviteDirectoryMembersArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fetchInvitedDirectoryMembers(header: PHeader.TAuthHeader, request: PDirectory.TFetchInvitedDirectoryMembersRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fetchInvitedDirectoryMembers", thrift.Thrift.MessageType.CALL, requestId);
            const args: FetchInvitedDirectoryMembersArgs = new FetchInvitedDirectoryMembersArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_removeDirectoryInvite(header: PHeader.TAuthHeader, request: PDirectory.TRemoveDirectoryInviteRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("removeDirectoryInvite", thrift.Thrift.MessageType.CALL, requestId);
            const args: RemoveDirectoryInviteArgs = new RemoveDirectoryInviteArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fetchDirectoryNotificationPreference(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryNotificationPreferenceRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fetchDirectoryNotificationPreference", thrift.Thrift.MessageType.CALL, requestId);
            const args: FetchDirectoryNotificationPreferenceArgs = new FetchDirectoryNotificationPreferenceArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_updateDirectoryNotificationPreference(header: PHeader.TAuthHeader, request: PDirectory.TUpdateDirectoryNotificationPreferenceRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("updateDirectoryNotificationPreference", thrift.Thrift.MessageType.CALL, requestId);
            const args: UpdateDirectoryNotificationPreferenceArgs = new UpdateDirectoryNotificationPreferenceArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public recv_addDirectoryMemberInfo(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: AddDirectoryMemberInfoResult = AddDirectoryMemberInfoResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else if (result.invalidPasscodeError != null) {
                    return callback(result.invalidPasscodeError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "addDirectoryMemberInfo failed: unknown result"));
                    }
                }
            }
        }
        public recv_updateDirectoryMemberInfo(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: UpdateDirectoryMemberInfoResult = UpdateDirectoryMemberInfoResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "updateDirectoryMemberInfo failed: unknown result"));
                    }
                }
            }
        }
        public recv_deleteDirectoryMemberInfo(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: DeleteDirectoryMemberInfoResult = DeleteDirectoryMemberInfoResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "deleteDirectoryMemberInfo failed: unknown result"));
                    }
                }
            }
        }
        public recv_fetchDirectoryMember(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FetchDirectoryMemberResult = FetchDirectoryMemberResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fetchDirectoryMember failed: unknown result"));
                    }
                }
            }
        }
        public recv_fetchLatestMemberInfo(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FetchLatestMemberInfoResult = FetchLatestMemberInfoResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fetchLatestMemberInfo failed: unknown result"));
                    }
                }
            }
        }
        public recv_fetchDirectoryMembers(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FetchDirectoryMembersResult = FetchDirectoryMembersResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fetchDirectoryMembers failed: unknown result"));
                    }
                }
            }
        }
        public recv_createMemberVCF(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: CreateMemberVCFResult = CreateMemberVCFResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "createMemberVCF failed: unknown result"));
                    }
                }
            }
        }
        public recv_createMembersVCF(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: CreateMembersVCFResult = CreateMembersVCFResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "createMembersVCF failed: unknown result"));
                    }
                }
            }
        }
        public recv_createMembersCSV(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: CreateMembersCSVResult = CreateMembersCSVResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "createMembersCSV failed: unknown result"));
                    }
                }
            }
        }
        public recv_inviteDirectoryMember(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: InviteDirectoryMemberResult = InviteDirectoryMemberResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "inviteDirectoryMember failed: unknown result"));
                    }
                }
            }
        }
        public recv_inviteDirectoryMembers(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: InviteDirectoryMembersResult = InviteDirectoryMembersResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "inviteDirectoryMembers failed: unknown result"));
                    }
                }
            }
        }
        public recv_fetchInvitedDirectoryMembers(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FetchInvitedDirectoryMembersResult = FetchInvitedDirectoryMembersResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fetchInvitedDirectoryMembers failed: unknown result"));
                    }
                }
            }
        }
        public recv_removeDirectoryInvite(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: RemoveDirectoryInviteResult = RemoveDirectoryInviteResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "removeDirectoryInvite failed: unknown result"));
                    }
                }
            }
        }
        public recv_fetchDirectoryNotificationPreference(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FetchDirectoryNotificationPreferenceResult = FetchDirectoryNotificationPreferenceResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fetchDirectoryNotificationPreference failed: unknown result"));
                    }
                }
            }
        }
        public recv_updateDirectoryNotificationPreference(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: UpdateDirectoryNotificationPreferenceResult = UpdateDirectoryNotificationPreferenceResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "updateDirectoryNotificationPreference failed: unknown result"));
                    }
                }
            }
        }
    }
    export interface IHandler {
        addDirectoryMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TAddDirectoryMemberInfoRequest): PDirectory.TAddDirectoryMemberInfoResponse | Promise<PDirectory.TAddDirectoryMemberInfoResponse>;
        updateDirectoryMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TUpdateDirectoryMemberInfoRequest): PDirectory.TUpdateDirectoryMemberInfoResponse | Promise<PDirectory.TUpdateDirectoryMemberInfoResponse>;
        deleteDirectoryMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TDeleteDirectoryMemberInfoRequest): PDirectory.TDeleteDirectoryMemberInfoResponse | Promise<PDirectory.TDeleteDirectoryMemberInfoResponse>;
        fetchDirectoryMember(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryMemberRequest): PDirectory.TFetchDirectoryMemberResponse | Promise<PDirectory.TFetchDirectoryMemberResponse>;
        fetchLatestMemberInfo(header: PHeader.TAuthHeader, request: PDirectory.TFetchLatestMemberInfoRequest): PDirectory.TFetchLatestMemberInfoResponse | Promise<PDirectory.TFetchLatestMemberInfoResponse>;
        fetchDirectoryMembers(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryMembersRequest): PDirectory.TFetchDirectoryMembersResponse | Promise<PDirectory.TFetchDirectoryMembersResponse>;
        createMemberVCF(header: PHeader.TAuthHeader, request: PDirectory.TCreateMemberVCFRequest): PDirectory.TCreateMemberVCFResponse | Promise<PDirectory.TCreateMemberVCFResponse>;
        createMembersVCF(header: PHeader.TAuthHeader, request: PDirectory.TCreateMembersVCFRequest): PDirectory.TCreateMembersVCFResponse | Promise<PDirectory.TCreateMembersVCFResponse>;
        createMembersCSV(header: PHeader.TAuthHeader, request: PDirectory.TCreateMembersCSVRequest): PDirectory.TCreateMembersCSVResponse | Promise<PDirectory.TCreateMembersCSVResponse>;
        inviteDirectoryMember(header: PHeader.TAuthHeader, request: PDirectory.TInviteDirectoryMemberRequest): PDirectory.TInviteDirectoryMemberResponse | Promise<PDirectory.TInviteDirectoryMemberResponse>;
        inviteDirectoryMembers(header: PHeader.TAuthHeader, request: PDirectory.TInviteDirectoryMembersRequest): PDirectory.TInviteDirectoryMembersResponse | Promise<PDirectory.TInviteDirectoryMembersResponse>;
        fetchInvitedDirectoryMembers(header: PHeader.TAuthHeader, request: PDirectory.TFetchInvitedDirectoryMembersRequest): PDirectory.TFetchInvitedDirectoryMembersResponse | Promise<PDirectory.TFetchInvitedDirectoryMembersResponse>;
        removeDirectoryInvite(header: PHeader.TAuthHeader, request: PDirectory.TRemoveDirectoryInviteRequest): PDirectory.TRemoveDirectoryInviteResponse | Promise<PDirectory.TRemoveDirectoryInviteResponse>;
        fetchDirectoryNotificationPreference(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryNotificationPreferenceRequest): PDirectory.TFetchDirectoryNotificationPreferenceResponse | Promise<PDirectory.TFetchDirectoryNotificationPreferenceResponse>;
        updateDirectoryNotificationPreference(header: PHeader.TAuthHeader, request: PDirectory.TUpdateDirectoryNotificationPreferenceRequest): PDirectory.TUpdateDirectoryNotificationPreferenceResponse | Promise<PDirectory.TUpdateDirectoryNotificationPreferenceResponse>;
    }
    export class Processor {
        public _handler: IHandler;
        constructor(handler: IHandler) {
            this._handler = handler;
        }
        public process(input: thrift.TProtocol, output: thrift.TProtocol): void {
            const metadata: thrift.TMessage = input.readMessageBegin();
            const fname: string = metadata.fname;
            const requestId: number = metadata.rseqid;
            const methodName: string = "process_" + fname;
            switch (methodName) {
                case "process_addDirectoryMemberInfo": {
                    this.process_addDirectoryMemberInfo(requestId, input, output);
                    return;
                }
                case "process_updateDirectoryMemberInfo": {
                    this.process_updateDirectoryMemberInfo(requestId, input, output);
                    return;
                }
                case "process_deleteDirectoryMemberInfo": {
                    this.process_deleteDirectoryMemberInfo(requestId, input, output);
                    return;
                }
                case "process_fetchDirectoryMember": {
                    this.process_fetchDirectoryMember(requestId, input, output);
                    return;
                }
                case "process_fetchLatestMemberInfo": {
                    this.process_fetchLatestMemberInfo(requestId, input, output);
                    return;
                }
                case "process_fetchDirectoryMembers": {
                    this.process_fetchDirectoryMembers(requestId, input, output);
                    return;
                }
                case "process_createMemberVCF": {
                    this.process_createMemberVCF(requestId, input, output);
                    return;
                }
                case "process_createMembersVCF": {
                    this.process_createMembersVCF(requestId, input, output);
                    return;
                }
                case "process_createMembersCSV": {
                    this.process_createMembersCSV(requestId, input, output);
                    return;
                }
                case "process_inviteDirectoryMember": {
                    this.process_inviteDirectoryMember(requestId, input, output);
                    return;
                }
                case "process_inviteDirectoryMembers": {
                    this.process_inviteDirectoryMembers(requestId, input, output);
                    return;
                }
                case "process_fetchInvitedDirectoryMembers": {
                    this.process_fetchInvitedDirectoryMembers(requestId, input, output);
                    return;
                }
                case "process_removeDirectoryInvite": {
                    this.process_removeDirectoryInvite(requestId, input, output);
                    return;
                }
                case "process_fetchDirectoryNotificationPreference": {
                    this.process_fetchDirectoryNotificationPreference(requestId, input, output);
                    return;
                }
                case "process_updateDirectoryNotificationPreference": {
                    this.process_updateDirectoryNotificationPreference(requestId, input, output);
                    return;
                }
                default: {
                    input.skip(thrift.Thrift.Type.STRUCT);
                    input.readMessageEnd();
                    const errMessage = "Unknown function " + fname;
                    const err = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN_METHOD, errMessage);
                    output.writeMessageBegin(fname, thrift.Thrift.MessageType.EXCEPTION, requestId);
                    err.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            }
        }
        public process_addDirectoryMemberInfo(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TAddDirectoryMemberInfoResponse>((resolve, reject): void => {
                try {
                    const args: AddDirectoryMemberInfoArgs = AddDirectoryMemberInfoArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.addDirectoryMemberInfo(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TAddDirectoryMemberInfoResponse): void => {
                const result: AddDirectoryMemberInfoResult = new AddDirectoryMemberInfoResult({ success: data });
                output.writeMessageBegin("addDirectoryMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: AddDirectoryMemberInfoResult = new AddDirectoryMemberInfoResult({ authFailedError: err });
                    output.writeMessageBegin("addDirectoryMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: AddDirectoryMemberInfoResult = new AddDirectoryMemberInfoResult({ invalidRequestError: err });
                    output.writeMessageBegin("addDirectoryMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidPasscodeException) {
                    const result: AddDirectoryMemberInfoResult = new AddDirectoryMemberInfoResult({ invalidPasscodeError: err });
                    output.writeMessageBegin("addDirectoryMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("addDirectoryMemberInfo", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_updateDirectoryMemberInfo(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TUpdateDirectoryMemberInfoResponse>((resolve, reject): void => {
                try {
                    const args: UpdateDirectoryMemberInfoArgs = UpdateDirectoryMemberInfoArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.updateDirectoryMemberInfo(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TUpdateDirectoryMemberInfoResponse): void => {
                const result: UpdateDirectoryMemberInfoResult = new UpdateDirectoryMemberInfoResult({ success: data });
                output.writeMessageBegin("updateDirectoryMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: UpdateDirectoryMemberInfoResult = new UpdateDirectoryMemberInfoResult({ authFailedError: err });
                    output.writeMessageBegin("updateDirectoryMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: UpdateDirectoryMemberInfoResult = new UpdateDirectoryMemberInfoResult({ invalidRequestError: err });
                    output.writeMessageBegin("updateDirectoryMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("updateDirectoryMemberInfo", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_deleteDirectoryMemberInfo(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TDeleteDirectoryMemberInfoResponse>((resolve, reject): void => {
                try {
                    const args: DeleteDirectoryMemberInfoArgs = DeleteDirectoryMemberInfoArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.deleteDirectoryMemberInfo(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TDeleteDirectoryMemberInfoResponse): void => {
                const result: DeleteDirectoryMemberInfoResult = new DeleteDirectoryMemberInfoResult({ success: data });
                output.writeMessageBegin("deleteDirectoryMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: DeleteDirectoryMemberInfoResult = new DeleteDirectoryMemberInfoResult({ authFailedError: err });
                    output.writeMessageBegin("deleteDirectoryMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: DeleteDirectoryMemberInfoResult = new DeleteDirectoryMemberInfoResult({ invalidRequestError: err });
                    output.writeMessageBegin("deleteDirectoryMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("deleteDirectoryMemberInfo", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fetchDirectoryMember(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TFetchDirectoryMemberResponse>((resolve, reject): void => {
                try {
                    const args: FetchDirectoryMemberArgs = FetchDirectoryMemberArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fetchDirectoryMember(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TFetchDirectoryMemberResponse): void => {
                const result: FetchDirectoryMemberResult = new FetchDirectoryMemberResult({ success: data });
                output.writeMessageBegin("fetchDirectoryMember", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: FetchDirectoryMemberResult = new FetchDirectoryMemberResult({ authFailedError: err });
                    output.writeMessageBegin("fetchDirectoryMember", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FetchDirectoryMemberResult = new FetchDirectoryMemberResult({ invalidRequestError: err });
                    output.writeMessageBegin("fetchDirectoryMember", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fetchDirectoryMember", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fetchLatestMemberInfo(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TFetchLatestMemberInfoResponse>((resolve, reject): void => {
                try {
                    const args: FetchLatestMemberInfoArgs = FetchLatestMemberInfoArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fetchLatestMemberInfo(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TFetchLatestMemberInfoResponse): void => {
                const result: FetchLatestMemberInfoResult = new FetchLatestMemberInfoResult({ success: data });
                output.writeMessageBegin("fetchLatestMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: FetchLatestMemberInfoResult = new FetchLatestMemberInfoResult({ authFailedError: err });
                    output.writeMessageBegin("fetchLatestMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FetchLatestMemberInfoResult = new FetchLatestMemberInfoResult({ invalidRequestError: err });
                    output.writeMessageBegin("fetchLatestMemberInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fetchLatestMemberInfo", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fetchDirectoryMembers(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TFetchDirectoryMembersResponse>((resolve, reject): void => {
                try {
                    const args: FetchDirectoryMembersArgs = FetchDirectoryMembersArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fetchDirectoryMembers(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TFetchDirectoryMembersResponse): void => {
                const result: FetchDirectoryMembersResult = new FetchDirectoryMembersResult({ success: data });
                output.writeMessageBegin("fetchDirectoryMembers", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: FetchDirectoryMembersResult = new FetchDirectoryMembersResult({ authFailedError: err });
                    output.writeMessageBegin("fetchDirectoryMembers", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FetchDirectoryMembersResult = new FetchDirectoryMembersResult({ invalidRequestError: err });
                    output.writeMessageBegin("fetchDirectoryMembers", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fetchDirectoryMembers", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_createMemberVCF(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TCreateMemberVCFResponse>((resolve, reject): void => {
                try {
                    const args: CreateMemberVCFArgs = CreateMemberVCFArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.createMemberVCF(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TCreateMemberVCFResponse): void => {
                const result: CreateMemberVCFResult = new CreateMemberVCFResult({ success: data });
                output.writeMessageBegin("createMemberVCF", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: CreateMemberVCFResult = new CreateMemberVCFResult({ authFailedError: err });
                    output.writeMessageBegin("createMemberVCF", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: CreateMemberVCFResult = new CreateMemberVCFResult({ invalidRequestError: err });
                    output.writeMessageBegin("createMemberVCF", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("createMemberVCF", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_createMembersVCF(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TCreateMembersVCFResponse>((resolve, reject): void => {
                try {
                    const args: CreateMembersVCFArgs = CreateMembersVCFArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.createMembersVCF(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TCreateMembersVCFResponse): void => {
                const result: CreateMembersVCFResult = new CreateMembersVCFResult({ success: data });
                output.writeMessageBegin("createMembersVCF", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: CreateMembersVCFResult = new CreateMembersVCFResult({ authFailedError: err });
                    output.writeMessageBegin("createMembersVCF", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: CreateMembersVCFResult = new CreateMembersVCFResult({ invalidRequestError: err });
                    output.writeMessageBegin("createMembersVCF", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("createMembersVCF", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_createMembersCSV(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TCreateMembersCSVResponse>((resolve, reject): void => {
                try {
                    const args: CreateMembersCSVArgs = CreateMembersCSVArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.createMembersCSV(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TCreateMembersCSVResponse): void => {
                const result: CreateMembersCSVResult = new CreateMembersCSVResult({ success: data });
                output.writeMessageBegin("createMembersCSV", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: CreateMembersCSVResult = new CreateMembersCSVResult({ authFailedError: err });
                    output.writeMessageBegin("createMembersCSV", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: CreateMembersCSVResult = new CreateMembersCSVResult({ invalidRequestError: err });
                    output.writeMessageBegin("createMembersCSV", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("createMembersCSV", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_inviteDirectoryMember(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TInviteDirectoryMemberResponse>((resolve, reject): void => {
                try {
                    const args: InviteDirectoryMemberArgs = InviteDirectoryMemberArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.inviteDirectoryMember(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TInviteDirectoryMemberResponse): void => {
                const result: InviteDirectoryMemberResult = new InviteDirectoryMemberResult({ success: data });
                output.writeMessageBegin("inviteDirectoryMember", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: InviteDirectoryMemberResult = new InviteDirectoryMemberResult({ authFailedError: err });
                    output.writeMessageBegin("inviteDirectoryMember", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: InviteDirectoryMemberResult = new InviteDirectoryMemberResult({ invalidRequestError: err });
                    output.writeMessageBegin("inviteDirectoryMember", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("inviteDirectoryMember", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_inviteDirectoryMembers(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TInviteDirectoryMembersResponse>((resolve, reject): void => {
                try {
                    const args: InviteDirectoryMembersArgs = InviteDirectoryMembersArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.inviteDirectoryMembers(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TInviteDirectoryMembersResponse): void => {
                const result: InviteDirectoryMembersResult = new InviteDirectoryMembersResult({ success: data });
                output.writeMessageBegin("inviteDirectoryMembers", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: InviteDirectoryMembersResult = new InviteDirectoryMembersResult({ authFailedError: err });
                    output.writeMessageBegin("inviteDirectoryMembers", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: InviteDirectoryMembersResult = new InviteDirectoryMembersResult({ invalidRequestError: err });
                    output.writeMessageBegin("inviteDirectoryMembers", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("inviteDirectoryMembers", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fetchInvitedDirectoryMembers(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TFetchInvitedDirectoryMembersResponse>((resolve, reject): void => {
                try {
                    const args: FetchInvitedDirectoryMembersArgs = FetchInvitedDirectoryMembersArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fetchInvitedDirectoryMembers(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TFetchInvitedDirectoryMembersResponse): void => {
                const result: FetchInvitedDirectoryMembersResult = new FetchInvitedDirectoryMembersResult({ success: data });
                output.writeMessageBegin("fetchInvitedDirectoryMembers", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: FetchInvitedDirectoryMembersResult = new FetchInvitedDirectoryMembersResult({ authFailedError: err });
                    output.writeMessageBegin("fetchInvitedDirectoryMembers", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FetchInvitedDirectoryMembersResult = new FetchInvitedDirectoryMembersResult({ invalidRequestError: err });
                    output.writeMessageBegin("fetchInvitedDirectoryMembers", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fetchInvitedDirectoryMembers", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_removeDirectoryInvite(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TRemoveDirectoryInviteResponse>((resolve, reject): void => {
                try {
                    const args: RemoveDirectoryInviteArgs = RemoveDirectoryInviteArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.removeDirectoryInvite(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TRemoveDirectoryInviteResponse): void => {
                const result: RemoveDirectoryInviteResult = new RemoveDirectoryInviteResult({ success: data });
                output.writeMessageBegin("removeDirectoryInvite", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: RemoveDirectoryInviteResult = new RemoveDirectoryInviteResult({ authFailedError: err });
                    output.writeMessageBegin("removeDirectoryInvite", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: RemoveDirectoryInviteResult = new RemoveDirectoryInviteResult({ invalidRequestError: err });
                    output.writeMessageBegin("removeDirectoryInvite", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("removeDirectoryInvite", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fetchDirectoryNotificationPreference(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TFetchDirectoryNotificationPreferenceResponse>((resolve, reject): void => {
                try {
                    const args: FetchDirectoryNotificationPreferenceArgs = FetchDirectoryNotificationPreferenceArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fetchDirectoryNotificationPreference(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TFetchDirectoryNotificationPreferenceResponse): void => {
                const result: FetchDirectoryNotificationPreferenceResult = new FetchDirectoryNotificationPreferenceResult({ success: data });
                output.writeMessageBegin("fetchDirectoryNotificationPreference", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: FetchDirectoryNotificationPreferenceResult = new FetchDirectoryNotificationPreferenceResult({ authFailedError: err });
                    output.writeMessageBegin("fetchDirectoryNotificationPreference", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FetchDirectoryNotificationPreferenceResult = new FetchDirectoryNotificationPreferenceResult({ invalidRequestError: err });
                    output.writeMessageBegin("fetchDirectoryNotificationPreference", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fetchDirectoryNotificationPreference", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_updateDirectoryNotificationPreference(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TUpdateDirectoryNotificationPreferenceResponse>((resolve, reject): void => {
                try {
                    const args: UpdateDirectoryNotificationPreferenceArgs = UpdateDirectoryNotificationPreferenceArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.updateDirectoryNotificationPreference(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TUpdateDirectoryNotificationPreferenceResponse): void => {
                const result: UpdateDirectoryNotificationPreferenceResult = new UpdateDirectoryNotificationPreferenceResult({ success: data });
                output.writeMessageBegin("updateDirectoryNotificationPreference", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: UpdateDirectoryNotificationPreferenceResult = new UpdateDirectoryNotificationPreferenceResult({ authFailedError: err });
                    output.writeMessageBegin("updateDirectoryNotificationPreference", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: UpdateDirectoryNotificationPreferenceResult = new UpdateDirectoryNotificationPreferenceResult({ invalidRequestError: err });
                    output.writeMessageBegin("updateDirectoryNotificationPreference", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("updateDirectoryNotificationPreference", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
    }
}
export namespace TDirectoryService {
    export interface ICreateDirectoryArgsArgs {
        request: PDirectory.TCreateDirectoryRequest;
    }
    export class CreateDirectoryArgs {
        public request: PDirectory.TCreateDirectoryRequest;
        constructor(args: ICreateDirectoryArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("CreateDirectoryArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): CreateDirectoryArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_77: PDirectory.TCreateDirectoryRequest = PDirectory.TCreateDirectoryRequest.read(input);
                            _args.request = value_77;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new CreateDirectoryArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read CreateDirectoryArgs from input");
            }
        }
    }
    export interface IUpdateDirectoryInfoArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TUpdateDirectoryInfoRequest;
    }
    export class UpdateDirectoryInfoArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TUpdateDirectoryInfoRequest;
        constructor(args: IUpdateDirectoryInfoArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateDirectoryInfoArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateDirectoryInfoArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_78: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_78;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_79: PDirectory.TUpdateDirectoryInfoRequest = PDirectory.TUpdateDirectoryInfoRequest.read(input);
                            _args.request = value_79;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new UpdateDirectoryInfoArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read UpdateDirectoryInfoArgs from input");
            }
        }
    }
    export interface IDeleteDirectoryArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TDeleteDirectoryRequest;
    }
    export class DeleteDirectoryArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TDeleteDirectoryRequest;
        constructor(args: IDeleteDirectoryArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("DeleteDirectoryArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): DeleteDirectoryArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_80: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_80;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_81: PDirectory.TDeleteDirectoryRequest = PDirectory.TDeleteDirectoryRequest.read(input);
                            _args.request = value_81;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new DeleteDirectoryArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read DeleteDirectoryArgs from input");
            }
        }
    }
    export interface IFetchDirectoryArgsArgs {
        request: PDirectory.TFetchDirectoryRequest;
    }
    export class FetchDirectoryArgs {
        public request: PDirectory.TFetchDirectoryRequest;
        constructor(args: IFetchDirectoryArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoryArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoryArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_82: PDirectory.TFetchDirectoryRequest = PDirectory.TFetchDirectoryRequest.read(input);
                            _args.request = value_82;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new FetchDirectoryArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FetchDirectoryArgs from input");
            }
        }
    }
    export interface IFetchDirectoryWithPasscodeArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TFetchDirectoryWithPasscodeRequest;
    }
    export class FetchDirectoryWithPasscodeArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TFetchDirectoryWithPasscodeRequest;
        constructor(args: IFetchDirectoryWithPasscodeArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoryWithPasscodeArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoryWithPasscodeArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_83: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_83;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_84: PDirectory.TFetchDirectoryWithPasscodeRequest = PDirectory.TFetchDirectoryWithPasscodeRequest.read(input);
                            _args.request = value_84;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new FetchDirectoryWithPasscodeArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FetchDirectoryWithPasscodeArgs from input");
            }
        }
    }
    export interface IFetchDirectoriesArgsArgs {
        header: PHeader.TAuthHeader;
        request: PDirectory.TFetchDirectoriesRequest;
    }
    export class FetchDirectoriesArgs {
        public header: PHeader.TAuthHeader;
        public request: PDirectory.TFetchDirectoriesRequest;
        constructor(args: IFetchDirectoriesArgsArgs) {
            if (args != null && args.header != null) {
                this.header = args.header;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[header] is unset!");
            }
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoriesArgs");
            if (this.header != null) {
                output.writeFieldBegin("header", thrift.Thrift.Type.STRUCT, 1);
                this.header.write(output);
                output.writeFieldEnd();
            }
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 2);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoriesArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_85: PHeader.TAuthHeader = PHeader.TAuthHeader.read(input);
                            _args.header = value_85;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_86: PDirectory.TFetchDirectoriesRequest = PDirectory.TFetchDirectoriesRequest.read(input);
                            _args.request = value_86;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.header !== undefined && _args.request !== undefined) {
                return new FetchDirectoriesArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read FetchDirectoriesArgs from input");
            }
        }
    }
    export interface IDeclineDirectoryInviteArgsArgs {
        request: PDirectory.TDeclineDirectoryInviteRequest;
    }
    export class DeclineDirectoryInviteArgs {
        public request: PDirectory.TDeclineDirectoryInviteRequest;
        constructor(args: IDeclineDirectoryInviteArgsArgs) {
            if (args != null && args.request != null) {
                this.request = args.request;
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[request] is unset!");
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("DeclineDirectoryInviteArgs");
            if (this.request != null) {
                output.writeFieldBegin("request", thrift.Thrift.Type.STRUCT, 1);
                this.request.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): DeclineDirectoryInviteArgs {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_87: PDirectory.TDeclineDirectoryInviteRequest = PDirectory.TDeclineDirectoryInviteRequest.read(input);
                            _args.request = value_87;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            if (_args.request !== undefined) {
                return new DeclineDirectoryInviteArgs(_args);
            }
            else {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read DeclineDirectoryInviteArgs from input");
            }
        }
    }
    export interface ICreateDirectoryResultArgs {
        success?: PDirectory.TCreateDirectoryResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class CreateDirectoryResult {
        public success?: PDirectory.TCreateDirectoryResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: ICreateDirectoryResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("CreateDirectoryResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): CreateDirectoryResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_88: PDirectory.TCreateDirectoryResponse = PDirectory.TCreateDirectoryResponse.read(input);
                            _args.success = value_88;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_89: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_89;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new CreateDirectoryResult(_args);
        }
    }
    export interface IUpdateDirectoryInfoResultArgs {
        success?: PDirectory.TUpdateDirectoryInfoResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class UpdateDirectoryInfoResult {
        public success?: PDirectory.TUpdateDirectoryInfoResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IUpdateDirectoryInfoResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("UpdateDirectoryInfoResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): UpdateDirectoryInfoResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_90: PDirectory.TUpdateDirectoryInfoResponse = PDirectory.TUpdateDirectoryInfoResponse.read(input);
                            _args.success = value_90;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_91: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_91;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_92: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_92;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new UpdateDirectoryInfoResult(_args);
        }
    }
    export interface IDeleteDirectoryResultArgs {
        success?: PDirectory.TDeleteDirectoryResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class DeleteDirectoryResult {
        public success?: PDirectory.TDeleteDirectoryResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IDeleteDirectoryResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("DeleteDirectoryResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): DeleteDirectoryResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_93: PDirectory.TDeleteDirectoryResponse = PDirectory.TDeleteDirectoryResponse.read(input);
                            _args.success = value_93;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_94: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_94;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_95: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_95;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new DeleteDirectoryResult(_args);
        }
    }
    export interface IFetchDirectoryResultArgs {
        success?: PDirectory.TFetchDirectoryResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class FetchDirectoryResult {
        public success?: PDirectory.TFetchDirectoryResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IFetchDirectoryResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoryResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoryResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_96: PDirectory.TFetchDirectoryResponse = PDirectory.TFetchDirectoryResponse.read(input);
                            _args.success = value_96;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_97: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_97;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FetchDirectoryResult(_args);
        }
    }
    export interface IFetchDirectoryWithPasscodeResultArgs {
        success?: PDirectory.TFetchDirectoryWithPasscodeResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class FetchDirectoryWithPasscodeResult {
        public success?: PDirectory.TFetchDirectoryWithPasscodeResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IFetchDirectoryWithPasscodeResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoryWithPasscodeResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoryWithPasscodeResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_98: PDirectory.TFetchDirectoryWithPasscodeResponse = PDirectory.TFetchDirectoryWithPasscodeResponse.read(input);
                            _args.success = value_98;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_99: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_99;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_100: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_100;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FetchDirectoryWithPasscodeResult(_args);
        }
    }
    export interface IFetchDirectoriesResultArgs {
        success?: PDirectory.TFetchDirectoriesResponse;
        authFailedError?: GenericExceptions.TAuthFailed;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class FetchDirectoriesResult {
        public success?: PDirectory.TFetchDirectoriesResponse;
        public authFailedError?: GenericExceptions.TAuthFailed;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IFetchDirectoriesResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.authFailedError != null) {
                this.authFailedError = args.authFailedError;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("FetchDirectoriesResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.authFailedError != null) {
                output.writeFieldBegin("authFailedError", thrift.Thrift.Type.STRUCT, 1);
                this.authFailedError.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 2);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): FetchDirectoriesResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_101: PDirectory.TFetchDirectoriesResponse = PDirectory.TFetchDirectoriesResponse.read(input);
                            _args.success = value_101;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_102: GenericExceptions.TAuthFailed = GenericExceptions.TAuthFailed.read(input);
                            _args.authFailedError = value_102;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 2:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_103: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_103;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new FetchDirectoriesResult(_args);
        }
    }
    export interface IDeclineDirectoryInviteResultArgs {
        success?: PDirectory.TDeclineDirectoryInviteResponse;
        invalidRequestError?: GenericExceptions.TInvalidRequest;
    }
    export class DeclineDirectoryInviteResult {
        public success?: PDirectory.TDeclineDirectoryInviteResponse;
        public invalidRequestError?: GenericExceptions.TInvalidRequest;
        constructor(args?: IDeclineDirectoryInviteResultArgs) {
            if (args != null && args.success != null) {
                this.success = args.success;
            }
            if (args != null && args.invalidRequestError != null) {
                this.invalidRequestError = args.invalidRequestError;
            }
        }
        public write(output: thrift.TProtocol): void {
            output.writeStructBegin("DeclineDirectoryInviteResult");
            if (this.success != null) {
                output.writeFieldBegin("success", thrift.Thrift.Type.STRUCT, 0);
                this.success.write(output);
                output.writeFieldEnd();
            }
            if (this.invalidRequestError != null) {
                output.writeFieldBegin("invalidRequestError", thrift.Thrift.Type.STRUCT, 1);
                this.invalidRequestError.write(output);
                output.writeFieldEnd();
            }
            output.writeFieldStop();
            output.writeStructEnd();
            return;
        }
        public static read(input: thrift.TProtocol): DeclineDirectoryInviteResult {
            input.readStructBegin();
            let _args: any = {};
            while (true) {
                const ret: thrift.TField = input.readFieldBegin();
                const fieldType: thrift.Thrift.Type = ret.ftype;
                const fieldId: number = ret.fid;
                if (fieldType === thrift.Thrift.Type.STOP) {
                    break;
                }
                switch (fieldId) {
                    case 0:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_104: PDirectory.TDeclineDirectoryInviteResponse = PDirectory.TDeclineDirectoryInviteResponse.read(input);
                            _args.success = value_104;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    case 1:
                        if (fieldType === thrift.Thrift.Type.STRUCT) {
                            const value_105: GenericExceptions.TInvalidRequest = GenericExceptions.TInvalidRequest.read(input);
                            _args.invalidRequestError = value_105;
                        }
                        else {
                            input.skip(fieldType);
                        }
                        break;
                    default: {
                        input.skip(fieldType);
                    }
                }
                input.readFieldEnd();
            }
            input.readStructEnd();
            return new DeclineDirectoryInviteResult(_args);
        }
    }
    export class Client {
        public _seqid: number;
        public _reqs: {
            [name: number]: (err: Error | object | undefined, val?: any) => void;
        };
        public output: thrift.TTransport;
        public protocol: new (trans: thrift.TTransport) => thrift.TProtocol;
        constructor(output: thrift.TTransport, protocol: new (trans: thrift.TTransport) => thrift.TProtocol) {
            this._seqid = 0;
            this._reqs = {};
            this.output = output;
            this.protocol = protocol;
        }
        public incrementSeqId(): number {
            return this._seqid += 1;
        }
        public createDirectory(request: PDirectory.TCreateDirectoryRequest): Promise<PDirectory.TCreateDirectoryResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TCreateDirectoryResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_createDirectory(request, requestId);
            });
        }
        public updateDirectoryInfo(header: PHeader.TAuthHeader, request: PDirectory.TUpdateDirectoryInfoRequest): Promise<PDirectory.TUpdateDirectoryInfoResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TUpdateDirectoryInfoResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_updateDirectoryInfo(header, request, requestId);
            });
        }
        public deleteDirectory(header: PHeader.TAuthHeader, request: PDirectory.TDeleteDirectoryRequest): Promise<PDirectory.TDeleteDirectoryResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TDeleteDirectoryResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_deleteDirectory(header, request, requestId);
            });
        }
        public fetchDirectory(request: PDirectory.TFetchDirectoryRequest): Promise<PDirectory.TFetchDirectoryResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TFetchDirectoryResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fetchDirectory(request, requestId);
            });
        }
        public fetchDirectoryWithPasscode(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryWithPasscodeRequest): Promise<PDirectory.TFetchDirectoryWithPasscodeResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TFetchDirectoryWithPasscodeResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fetchDirectoryWithPasscode(header, request, requestId);
            });
        }
        public fetchDirectories(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoriesRequest): Promise<PDirectory.TFetchDirectoriesResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TFetchDirectoriesResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_fetchDirectories(header, request, requestId);
            });
        }
        public declineDirectoryInvite(request: PDirectory.TDeclineDirectoryInviteRequest): Promise<PDirectory.TDeclineDirectoryInviteResponse> {
            const requestId: number = this.incrementSeqId();
            return new Promise<PDirectory.TDeclineDirectoryInviteResponse>((resolve, reject): void => {
                this._reqs[requestId] = (error, result) => {
                    delete this._reqs[requestId];
                    if (error != null) {
                        reject(error);
                    }
                    else {
                        resolve(result);
                    }
                };
                this.send_declineDirectoryInvite(request, requestId);
            });
        }
        public send_createDirectory(request: PDirectory.TCreateDirectoryRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("createDirectory", thrift.Thrift.MessageType.CALL, requestId);
            const args: CreateDirectoryArgs = new CreateDirectoryArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_updateDirectoryInfo(header: PHeader.TAuthHeader, request: PDirectory.TUpdateDirectoryInfoRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("updateDirectoryInfo", thrift.Thrift.MessageType.CALL, requestId);
            const args: UpdateDirectoryInfoArgs = new UpdateDirectoryInfoArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_deleteDirectory(header: PHeader.TAuthHeader, request: PDirectory.TDeleteDirectoryRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("deleteDirectory", thrift.Thrift.MessageType.CALL, requestId);
            const args: DeleteDirectoryArgs = new DeleteDirectoryArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fetchDirectory(request: PDirectory.TFetchDirectoryRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fetchDirectory", thrift.Thrift.MessageType.CALL, requestId);
            const args: FetchDirectoryArgs = new FetchDirectoryArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fetchDirectoryWithPasscode(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryWithPasscodeRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fetchDirectoryWithPasscode", thrift.Thrift.MessageType.CALL, requestId);
            const args: FetchDirectoryWithPasscodeArgs = new FetchDirectoryWithPasscodeArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_fetchDirectories(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoriesRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("fetchDirectories", thrift.Thrift.MessageType.CALL, requestId);
            const args: FetchDirectoriesArgs = new FetchDirectoriesArgs({ header, request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public send_declineDirectoryInvite(request: PDirectory.TDeclineDirectoryInviteRequest, requestId: number): void {
            const output: thrift.TProtocol = new this.protocol(this.output);
            output.writeMessageBegin("declineDirectoryInvite", thrift.Thrift.MessageType.CALL, requestId);
            const args: DeclineDirectoryInviteArgs = new DeclineDirectoryInviteArgs({ request });
            args.write(output);
            output.writeMessageEnd();
            this.output.flush();
            return;
        }
        public recv_createDirectory(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: CreateDirectoryResult = CreateDirectoryResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "createDirectory failed: unknown result"));
                    }
                }
            }
        }
        public recv_updateDirectoryInfo(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: UpdateDirectoryInfoResult = UpdateDirectoryInfoResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "updateDirectoryInfo failed: unknown result"));
                    }
                }
            }
        }
        public recv_deleteDirectory(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: DeleteDirectoryResult = DeleteDirectoryResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "deleteDirectory failed: unknown result"));
                    }
                }
            }
        }
        public recv_fetchDirectory(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FetchDirectoryResult = FetchDirectoryResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fetchDirectory failed: unknown result"));
                    }
                }
            }
        }
        public recv_fetchDirectoryWithPasscode(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FetchDirectoryWithPasscodeResult = FetchDirectoryWithPasscodeResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fetchDirectoryWithPasscode failed: unknown result"));
                    }
                }
            }
        }
        public recv_fetchDirectories(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: FetchDirectoriesResult = FetchDirectoriesResult.read(input);
                input.readMessageEnd();
                if (result.authFailedError != null) {
                    return callback(result.authFailedError);
                }
                else if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "fetchDirectories failed: unknown result"));
                    }
                }
            }
        }
        public recv_declineDirectoryInvite(input: thrift.TProtocol, mtype: thrift.Thrift.MessageType, requestId: number): void {
            const noop = (): any => null;
            const callback = this._reqs[requestId] || noop;
            if (mtype === thrift.Thrift.MessageType.EXCEPTION) {
                const x: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException();
                x.read(input);
                input.readMessageEnd();
                return callback(x);
            }
            else {
                const result: DeclineDirectoryInviteResult = DeclineDirectoryInviteResult.read(input);
                input.readMessageEnd();
                if (result.invalidRequestError != null) {
                    return callback(result.invalidRequestError);
                }
                else {
                    if (result.success != null) {
                        return callback(undefined, result.success);
                    }
                    else {
                        return callback(new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, "declineDirectoryInvite failed: unknown result"));
                    }
                }
            }
        }
    }
    export interface IHandler {
        createDirectory(request: PDirectory.TCreateDirectoryRequest): PDirectory.TCreateDirectoryResponse | Promise<PDirectory.TCreateDirectoryResponse>;
        updateDirectoryInfo(header: PHeader.TAuthHeader, request: PDirectory.TUpdateDirectoryInfoRequest): PDirectory.TUpdateDirectoryInfoResponse | Promise<PDirectory.TUpdateDirectoryInfoResponse>;
        deleteDirectory(header: PHeader.TAuthHeader, request: PDirectory.TDeleteDirectoryRequest): PDirectory.TDeleteDirectoryResponse | Promise<PDirectory.TDeleteDirectoryResponse>;
        fetchDirectory(request: PDirectory.TFetchDirectoryRequest): PDirectory.TFetchDirectoryResponse | Promise<PDirectory.TFetchDirectoryResponse>;
        fetchDirectoryWithPasscode(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoryWithPasscodeRequest): PDirectory.TFetchDirectoryWithPasscodeResponse | Promise<PDirectory.TFetchDirectoryWithPasscodeResponse>;
        fetchDirectories(header: PHeader.TAuthHeader, request: PDirectory.TFetchDirectoriesRequest): PDirectory.TFetchDirectoriesResponse | Promise<PDirectory.TFetchDirectoriesResponse>;
        declineDirectoryInvite(request: PDirectory.TDeclineDirectoryInviteRequest): PDirectory.TDeclineDirectoryInviteResponse | Promise<PDirectory.TDeclineDirectoryInviteResponse>;
    }
    export class Processor {
        public _handler: IHandler;
        constructor(handler: IHandler) {
            this._handler = handler;
        }
        public process(input: thrift.TProtocol, output: thrift.TProtocol): void {
            const metadata: thrift.TMessage = input.readMessageBegin();
            const fname: string = metadata.fname;
            const requestId: number = metadata.rseqid;
            const methodName: string = "process_" + fname;
            switch (methodName) {
                case "process_createDirectory": {
                    this.process_createDirectory(requestId, input, output);
                    return;
                }
                case "process_updateDirectoryInfo": {
                    this.process_updateDirectoryInfo(requestId, input, output);
                    return;
                }
                case "process_deleteDirectory": {
                    this.process_deleteDirectory(requestId, input, output);
                    return;
                }
                case "process_fetchDirectory": {
                    this.process_fetchDirectory(requestId, input, output);
                    return;
                }
                case "process_fetchDirectoryWithPasscode": {
                    this.process_fetchDirectoryWithPasscode(requestId, input, output);
                    return;
                }
                case "process_fetchDirectories": {
                    this.process_fetchDirectories(requestId, input, output);
                    return;
                }
                case "process_declineDirectoryInvite": {
                    this.process_declineDirectoryInvite(requestId, input, output);
                    return;
                }
                default: {
                    input.skip(thrift.Thrift.Type.STRUCT);
                    input.readMessageEnd();
                    const errMessage = "Unknown function " + fname;
                    const err = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN_METHOD, errMessage);
                    output.writeMessageBegin(fname, thrift.Thrift.MessageType.EXCEPTION, requestId);
                    err.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            }
        }
        public process_createDirectory(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TCreateDirectoryResponse>((resolve, reject): void => {
                try {
                    const args: CreateDirectoryArgs = CreateDirectoryArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.createDirectory(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TCreateDirectoryResponse): void => {
                const result: CreateDirectoryResult = new CreateDirectoryResult({ success: data });
                output.writeMessageBegin("createDirectory", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: CreateDirectoryResult = new CreateDirectoryResult({ invalidRequestError: err });
                    output.writeMessageBegin("createDirectory", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("createDirectory", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_updateDirectoryInfo(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TUpdateDirectoryInfoResponse>((resolve, reject): void => {
                try {
                    const args: UpdateDirectoryInfoArgs = UpdateDirectoryInfoArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.updateDirectoryInfo(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TUpdateDirectoryInfoResponse): void => {
                const result: UpdateDirectoryInfoResult = new UpdateDirectoryInfoResult({ success: data });
                output.writeMessageBegin("updateDirectoryInfo", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: UpdateDirectoryInfoResult = new UpdateDirectoryInfoResult({ authFailedError: err });
                    output.writeMessageBegin("updateDirectoryInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: UpdateDirectoryInfoResult = new UpdateDirectoryInfoResult({ invalidRequestError: err });
                    output.writeMessageBegin("updateDirectoryInfo", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("updateDirectoryInfo", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_deleteDirectory(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TDeleteDirectoryResponse>((resolve, reject): void => {
                try {
                    const args: DeleteDirectoryArgs = DeleteDirectoryArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.deleteDirectory(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TDeleteDirectoryResponse): void => {
                const result: DeleteDirectoryResult = new DeleteDirectoryResult({ success: data });
                output.writeMessageBegin("deleteDirectory", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: DeleteDirectoryResult = new DeleteDirectoryResult({ authFailedError: err });
                    output.writeMessageBegin("deleteDirectory", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: DeleteDirectoryResult = new DeleteDirectoryResult({ invalidRequestError: err });
                    output.writeMessageBegin("deleteDirectory", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("deleteDirectory", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fetchDirectory(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TFetchDirectoryResponse>((resolve, reject): void => {
                try {
                    const args: FetchDirectoryArgs = FetchDirectoryArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fetchDirectory(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TFetchDirectoryResponse): void => {
                const result: FetchDirectoryResult = new FetchDirectoryResult({ success: data });
                output.writeMessageBegin("fetchDirectory", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FetchDirectoryResult = new FetchDirectoryResult({ invalidRequestError: err });
                    output.writeMessageBegin("fetchDirectory", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fetchDirectory", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fetchDirectoryWithPasscode(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TFetchDirectoryWithPasscodeResponse>((resolve, reject): void => {
                try {
                    const args: FetchDirectoryWithPasscodeArgs = FetchDirectoryWithPasscodeArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fetchDirectoryWithPasscode(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TFetchDirectoryWithPasscodeResponse): void => {
                const result: FetchDirectoryWithPasscodeResult = new FetchDirectoryWithPasscodeResult({ success: data });
                output.writeMessageBegin("fetchDirectoryWithPasscode", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: FetchDirectoryWithPasscodeResult = new FetchDirectoryWithPasscodeResult({ authFailedError: err });
                    output.writeMessageBegin("fetchDirectoryWithPasscode", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FetchDirectoryWithPasscodeResult = new FetchDirectoryWithPasscodeResult({ invalidRequestError: err });
                    output.writeMessageBegin("fetchDirectoryWithPasscode", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fetchDirectoryWithPasscode", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_fetchDirectories(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TFetchDirectoriesResponse>((resolve, reject): void => {
                try {
                    const args: FetchDirectoriesArgs = FetchDirectoriesArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.fetchDirectories(args.header, args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TFetchDirectoriesResponse): void => {
                const result: FetchDirectoriesResult = new FetchDirectoriesResult({ success: data });
                output.writeMessageBegin("fetchDirectories", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TAuthFailed) {
                    const result: FetchDirectoriesResult = new FetchDirectoriesResult({ authFailedError: err });
                    output.writeMessageBegin("fetchDirectories", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: FetchDirectoriesResult = new FetchDirectoriesResult({ invalidRequestError: err });
                    output.writeMessageBegin("fetchDirectories", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("fetchDirectories", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
        public process_declineDirectoryInvite(requestId: number, input: thrift.TProtocol, output: thrift.TProtocol): void {
            new Promise<PDirectory.TDeclineDirectoryInviteResponse>((resolve, reject): void => {
                try {
                    const args: DeclineDirectoryInviteArgs = DeclineDirectoryInviteArgs.read(input);
                    input.readMessageEnd();
                    resolve(this._handler.declineDirectoryInvite(args.request));
                }
                catch (err) {
                    reject(err);
                }
            }).then((data: PDirectory.TDeclineDirectoryInviteResponse): void => {
                const result: DeclineDirectoryInviteResult = new DeclineDirectoryInviteResult({ success: data });
                output.writeMessageBegin("declineDirectoryInvite", thrift.Thrift.MessageType.REPLY, requestId);
                result.write(output);
                output.writeMessageEnd();
                output.flush();
                return;
            }).catch((err: Error): void => {
                if (err instanceof GenericExceptions.TInvalidRequest) {
                    const result: DeclineDirectoryInviteResult = new DeclineDirectoryInviteResult({ invalidRequestError: err });
                    output.writeMessageBegin("declineDirectoryInvite", thrift.Thrift.MessageType.REPLY, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
                else {
                    const result: thrift.Thrift.TApplicationException = new thrift.Thrift.TApplicationException(thrift.Thrift.TApplicationExceptionType.UNKNOWN, err.message);
                    output.writeMessageBegin("declineDirectoryInvite", thrift.Thrift.MessageType.EXCEPTION, requestId);
                    result.write(output);
                    output.writeMessageEnd();
                    output.flush();
                    return;
                }
            });
        }
    }
}
